import { createFileRoute } from '@tanstack/react-router'
import { KuraList } from '@/components/kura-list'
import { requireAuth } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/kura/')({
  beforeLoad: requireAuth,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      search: (search?.search as string) || '',
    }
  },
  component: KuraListPage,
})

function KuraListPage() {
  const { search } = Route.useSearch()

  return (
    <div className="space-y-6 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Kura Listesi</h1>
      </div>
      {/* 
        KuraList will use its own queries, but the data is already 
        pre-loaded by the loader, eliminating loading flashes! 
      */}
      <KuraList initialSearch={search} />
    </div>
  )
}